
    import {Component, Prop, Vue} from "vue-property-decorator";
    import {LocationInterface} from "@/shared/interfaces/LocationInterface";
    import Favorite from "@/MarketSearch/components/Favorite.vue";
    import {OpeningHoursInterface} from "@/shared/interfaces/OpeningHoursInterface";
    import {UserLocation} from "@/shared/services/UserLocation";
    import {mapActions} from "vuex";

    type TimeData = { hours: number, minutes: number };

    @Component({
        name: 'list-item',
        components: {Favorite},
        methods: {
            ...mapActions(['setFavorite'])
        }
    })
    export default class Map extends Vue {
        @Prop({required: true}) item!: LocationInterface;
        @Prop({default: true}) showDetailsButton!: boolean;
        @Prop({default: true}) showOpeningHours!: boolean;
        @Prop({default: true}) showDistance!: boolean;
        @Prop({default: true}) showAddress!: boolean;
        @Prop({default: false}) favSelectsItem!: boolean;
        @Prop({default: 'SOUTH_BAVARIA'}) favoriteFilter!: string;
        @Prop({default: 'SOUTH_BAVARIA'}) possibleFavorites!: string;

        private setFavorite!: (identifier: string | null) => void;

        get openingHours(): OpeningHoursInterface | null {
            const days = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
            const dayOfWeek = days[(new Date()).getDay()];
            for (let openingHours of this.item.openingHours) {
                if (openingHours.dayOfWeek === dayOfWeek)
                    return openingHours;
            }
            return null;
        }

        get specialOpeningHours(): OpeningHoursInterface | null {
          const interval = 1000 * 60 * 60 * 24;
          const timestampToday = Math.floor(Date.now() / interval) * interval;
          if(this.item.specialOpeningHours) {
            for (let openingHours of this.item.specialOpeningHours) {
              if (openingHours.date && parseInt(openingHours.date) === timestampToday) {
                return openingHours;
              }
            }
          }
          return null;
        }

        get canBeMarkedAsFavorite(): boolean {
            return this.possibleFavorites.includes(this.item.keywords?.locationType || '');
        }

        toggleFavorite(event: Event, identifier: string) {
            if (UserLocation.has() && UserLocation.get() === identifier) {
                return this.deactivateFavorite();
            }
            this.activateFavorite(identifier);
        }

        activateFavorite(identifier: string) {
            this.setFavorite(identifier);
            UserLocation.set(identifier, this.item.city || '');
        }

        deactivateFavorite() {
            this.setFavorite(null);
            UserLocation.remove();
        }

        get offerLink() {
            let url;
            if(this.item && this.item.keywords && this.item.city) {
              const locationType = this.item.keywords.locationType;
              url = this.item.baseUrl + '/angebote';
              if (locationType == 'FOOD_SERVICE' || locationType == 'SOUTH_BAVARIA') {
                let loc = this.item.website?.substring(this.item.website?.lastIndexOf("/"));
                url += loc;
              }
            }
            return url;
        }
    }
